import React from 'react';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { INFO_TIMELINE_ICON } from '@Images';

const OtpContainer = styled.div`
  width: 32px;
  height: 14px;
  object-fit: contain;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 13px;
  font-weight: 300;
  font-stretch: normal;
  font-style: oblique;
  line-height: 1.4;
  letter-spacing: normal;
  color: ${COLORS.brandPrimary};
`;

const IconWrapper = styled.div`
  i {
    font-size: 1em !important;
    margin-left: -8px !important;
    margin-top: -5px !important;
  }
`;

const Resend = styled.div`
  button {
    width: 47px;
    height: 19px;
    object-fit: contain;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    background: none;
    text-align: right;
    color: ${COLORS.brandPrimary};
    text-decoration: underline;
    border: none;
    margin-right: 10px;
  }
`;
const Edit = styled.div`
  button {
    width: 26px;
    height: 19px;
    object-fit: contain;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    background: none;
    color: ${COLORS.brandPrimary};
    text-decoration: underline;
    border: none;
    margin-right: 10px;
  }
`;

const FieldWrapper = styled.div`
  position: relative;
`;

const InfoIconImg = styled.img`
  position: absolute;
  right: -22px;
  top: 15px;
  width: 15px;
  cursor: pointer;
`;

const mobileStyle = {
  height: '50px'
};
const verifyStyle = {
  height: '50px',
  width: '318px'
};

function MobileTextField(props) {
  const editButton = () => {
    props.setEdit();
    props.clearTimeOut();
  };

  const Sg_US_Flow =
    props.input.value.length > 7 ? (
      <InputAdornment position="end">
        <IconWrapper>
          <Icon name="circle check" color="green" size="small" />{' '}
        </IconWrapper>
      </InputAdornment>
    ) : null;

  const showEditIcon = props.is_phone_verified ? (
    <InputAdornment position="end">
      <IconWrapper>
        <Icon name="circle check" color="green" size="small" />{' '}
      </IconWrapper>
    </InputAdornment>
  ) : props && props.showEdit ? (
    <InputAdornment position="end">
      <Edit>
        <button href="#text-buttons" type="button" color="primary" onClick={editButton}>
          Edit
        </button>
      </Edit>
    </InputAdornment>
  ) : null;

  const showOtpCountdown =
    props.input.name === 'mobile_otp' ? (
      props.tip !== '' ? (
        <InputAdornment position="end">
          <OtpContainer>{props.countdown}sec</OtpContainer>
        </InputAdornment>
      ) : (
        <InputAdornment position="end">
          <Resend>
            <button type="button" onClick={props.resendOtp}>
              Resend
            </button>
          </Resend>
        </InputAdornment>
      )
    ) : null;

  return (
    <FieldWrapper>
      <FormControl variant="outlined" fullWidth>
        <InputLabel
          htmlFor="outlined-adornment-amount"
          style={props.meta.touched && props.meta.error ? { color: COLORS.newerror } : {}}
        >
          {props.placeholder}
        </InputLabel>
        <OutlinedInput
          style={props.styleCheck ? verifyStyle : mobileStyle}
          id="outlined-multiline-static"
          name={props.input.name}
          type={props.type}
          label={props.placeholder}
          {...props.input}
          endAdornment={
            props.disablePinVerification
              ? Sg_US_Flow
              : props.input.name === 'mobile_otp'
              ? showOtpCountdown
              : showEditIcon
          }
          aria-describedby="standard-weight-helper-text"
          disabled={props.disabled}
          inputProps={{
            'aria-label': 'weight'
          }}
          variant={'outlined'}
          defaultValue={props.defaultValue}
          error={props.meta.touched && props.meta.error ? true : false}
          ref={(ref) => (props?.getInputRef ? props?.getInputRef(ref) : props?.ref)}
        />
        {props.inline !== null ? (
          <FormHelperText>
            {<p style={{ color: COLORS.newerror, fontSize: '12px' }}>{props.inline}</p>}
          </FormHelperText>
        ) : null}
        {props.meta.touched && props.meta.error && (
          <FormHelperText style={{ color: COLORS.newerror, fontSize: '12px' }}>
            {props.meta.error}
          </FormHelperText>
        )}
      </FormControl>
      {props.tooltip && (
        <Popup
          trigger={<InfoIconImg src={INFO_TIMELINE_ICON} alt="info-icon" />}
          content={props.tooltip}
          size="tiny"
          position="right center"
        />
      )}
    </FieldWrapper>
  );
}

MobileTextField.propTypes = {
  meta: PropTypes.any,
  active: PropTypes.bool,
  showhelperText: PropTypes.any,
  error: PropTypes.string,
  input: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  countdown: PropTypes.string,
  resendOtp: PropTypes.func,
  clearTimeOut: PropTypes.func,
  counter: PropTypes.number,
  tip: PropTypes.string,
  inline: PropTypes.string,
  setEdit: PropTypes.func,
  showEdit: PropTypes.bool,
  disabled: PropTypes.bool,
  is_phone_verified: PropTypes.bool,
  styleCheck: PropTypes.string,
  disablePinVerification: PropTypes.bool,
  ref: PropTypes.any,
  getInputRef: PropTypes.any,
  tooltip: PropTypes.string
};

export default MobileTextField;
